import {useState, useEffect} from "react";
import Table, { ColumnsType } from 'antd/es/table';

import {Input} from "antd";
const {Search} = Input;

export interface InputProps {
  data: any,
  columns: ColumnsType<any>}


const SearchBar = ({data,columns}:InputProps) => {
    const [filteredData, setFilteredData] = useState([]);
    const [input, setInput] = useState("");

    useEffect(() => {
      setFilteredData(data);
      setInput("");
    }, [data]);

  const handleFilter = (e:any) => {
  console.log(e);
  const searchInput = e.target.value;
  setInput(searchInput);

  const newFilter = data.filter((value:any) => {
    return (value.ProcessName ?value.ProcessName.toLowerCase().includes(searchInput.toLowerCase()): "");       
  });


  if (searchInput === "") {
    setFilteredData(data);
  } 
  else 
  {
    setFilteredData(newFilter);
  }
};

return(
      <div className="search">
          <div className="searchInputs">
          <Search
            placeholder="فرآیند" 
            value={input}
            onChange={(e) => handleFilter(e)}       
            enterButton
          />
        </div>
        {
        filteredData.length != 0 && (
        <div className="dataResult">
          <Table columns={columns} dataSource={filteredData} />
        </div>
    )}
      </div>  
 )
      
}
export default SearchBar